import React, { useState } from 'react';
import { Link } from 'react-router';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from '../api/client';

export const Guardians = ({ family, familyUsers, currentUserId, isOwner, t, onDeleteSuccess }) => {
  const queryClient = useQueryClient();
  const [deletingId, setDeletingId] = useState(null);

  const deleteMutation = useMutation({
    mutationFn: async (familyUserId) => {
      const response = await apiClient.delete(`/guardians/family_users/${familyUserId}`);
      return response.data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['dashboard'] });
      setDeletingId(null);
      if (onDeleteSuccess && data.message) {
        onDeleteSuccess(data.message);
      }
    },
    onError: () => {
      setDeletingId(null);
    }
  });

  const handleDelete = (familyUser) => {
    if (!confirm(t('dashboard.index.guardians.confirm_remove', { name: familyUser.name }))) {
      return;
    }

    setDeletingId(familyUser.id);
    deleteMutation.mutate(familyUser.id);
  };

  return (
    <div className="card border rounded-3 mb-4">
      <div className="card-body p-4">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <div className="d-flex align-items-center">
            <div className="d-inline-flex align-items-center justify-content-center rounded-2 me-3" style={{ width: '48px', height: '48px', background: 'linear-gradient(135deg, #4ade80 0%, #16a34a 100%)' }}>
              <i className="bi bi-shield-check text-white" style={{ fontSize: '25px' }}></i>
            </div>
            <div>
              <h3 className="h5 fw-bold mb-1">{t('dashboard.index.guardians.title')}</h3>
              <p className="text-muted small mb-0">{t('dashboard.index.guardians.description')}</p>
            </div>
          </div>
          <Link
            to="/guardians/new"
            className="btn d-flex align-items-center justify-content-center rounded-3"
            aria-label={t('dashboard.index.guardians.add_guardian')}
            data-testid="add-guardian-btn"
            style={{
              width: '40px',
              height: '40px',
              background: '#16a34a',
              border: 'none',
              boxShadow: '0px 4px 6px #bbf7d0, 0px 10px 15px #bbf7d0'
            }}
          >
            <i className="bi bi-plus-lg text-white" style={{ fontSize: '18px' }}></i>
          </Link>
        </div>

        {familyUsers.map((familyUser) => (
          <div key={familyUser.id} className="bg-light rounded-2 p-3 mb-3">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                {familyUser.avatar_url ? (
                  <img src={familyUser.avatar_url} alt={familyUser.name} className="rounded-circle me-3" width="48" height="48" />
                ) : (
                  <div className="rounded-circle bg-secondary text-white d-flex align-items-center justify-content-center me-3" style={{ width: '48px', height: '48px' }}>
                    {familyUser.name?.charAt(0)?.toUpperCase() || 'U'}
                  </div>
                )}
                <div>
                  <h5 className="fw-semibold mb-1">{familyUser.name}</h5>
                  <p className="text-muted small mb-1">{familyUser.email}</p>
                  <span className="badge bg-primary bg-opacity-10 text-primary">{t(`dashboard.index.guardians.roles.${familyUser.role}`)}</span>
                </div>
              </div>
              {isOwner && !familyUser.is_current_user && (
                <button
                  type="button"
                  onClick={() => handleDelete(familyUser)}
                  className="btn btn-sm btn-link text-danger"
                  disabled={deletingId === familyUser.id}
                >
                  {deletingId === familyUser.id ? (
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  ) : (
                    <i className="bi bi-trash"></i>
                  )}
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
